/**
 * Navigation Item
 * @class
 */
class NavItem {
	/**
	 * @constructor
	 * @param {object} params - Parameters
	 */
	constructor({
		view = null,
		title = null,
		icon = null,
		permission = null,
		ff = null,
		exact = false,
	} = {}) {
		this.view = view
		this.title = title
		this.icon = icon
		this.permission = permission
		this.ff = ff
		this.exact = exact
		this._items = []
	}

	/**
	 * Items getter
	 */
	get items() {
		return this._items.length ? this._items : null
	}

	/**
	 * Add sub-item in navigation item
	 * @param {object} item - Sub-item
	 * @return {object} - This
	 */
	add(item) {
		if (!(item instanceof NavItem)) {
			console.warn('NavItem can only add NavItem instances as sub-item')
			return this
		}

		this._items.push(item)
		return this
	}
}


export default NavItem
